import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRJiraTicketStatusBadge from '../NRJiraTicketStatusBadge';

function NRJiraTicketStatusFormatter({ value, row }) {
  return <NRJiraTicketStatusBadge status={value} statusCategoryColor={row?.statusCategoryColor} />;
}

export function NRJiraTicketStatusProvider(props) {
  return <DataTypeProvider formatterComponent={NRJiraTicketStatusFormatter} {...props} />;
}
